import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing } from 'stylesheet';
import { Beop } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "BeopBlockstyle__Container",
  componentId: "sc-16pp0od-0"
})(["display:flex;justify-content:center;padding:", ";color:", ";font-size:", ";background-color:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(3.5), colorUsage.beopBlock.foreground, fontSize.smaller, colorUsage.beopBlock.background, colorUsage.beopBlock.border, borderRadius.medium);
var BeopContainer = styled.div.withConfig({
  displayName: "BeopBlockstyle__BeopContainer",
  componentId: "sc-16pp0od-1"
})(["display:flex;align-items:center;"]);
var BeopIcon = styled(Beop).withConfig({
  displayName: "BeopBlockstyle__BeopIcon",
  componentId: "sc-16pp0od-2"
})(["width:", ";height:", ";margin-right:", ";path{fill:", ";}"], fontSize.smaller, fontSize.smaller, getSpacing(0.5), colorUsage.beopBlock.foreground);
export { BeopContainer, BeopIcon, Container };